import { Weblog } from '@ks/weblogger/lib/log.browser';

// 引入雷达合集SDK
import Radar from '@ks-radar/radar';

export { Weblog, Radar };
